export const settingsSelector = state => state.setting.appSettings;
export const activePageInfoSelector = state => state.setting.activePageInfo;